import React from 'react'
import Layout from 'antd/es/layout'
import 'antd/es/layout/style'

import { Link, withRouter } from 'react-router-dom'
import styles from './style.module.scss'
import backgroundImage from '../../assets/1.jpeg'

@withRouter
class LoginLayout extends React.PureComponent {
  state = {
    backgroundNumber: 1,
    backgroundEnabled: true,
  }

  changeBackground = () => {
    const { backgroundNumber } = this.state
    this.setState({
      backgroundEnabled: true,
      backgroundNumber: backgroundNumber === 5 ? 1 : backgroundNumber + 1,
    })
  }

  toggleBackground = () => {
    const { backgroundEnabled } = this.state
    this.setState({
      backgroundEnabled: !backgroundEnabled,
    })
  }

  render() {
    const { children } = this.props
    const { backgroundNumber, backgroundEnabled } = this.state

    return (
      <Layout>
        <Layout.Content>
          <div
            className={backgroundEnabled ? `${styles.layout} ${styles.light}` : `${styles.layout}`}
            style={{
              backgroundImage: backgroundEnabled ? `url('${backgroundImage}')` : `none`,
            }}
          >
            <div className={styles.header}>
              {/* <div className={styles.logo}>
                <Link to="/">
                  {!backgroundEnabled && <h1 style={{ color: 'white' }}>FMS</h1>}
                  {backgroundEnabled && <h1 style={{ color: 'white' }}>FMS</h1>}
                </Link>
              </div> */}
            </div>
            <div className={styles.content}>{children}</div>
            <div className={`${styles.footer} text-center`}>
              <p>&copy; 2019 FMS. Todos los derechos reservados.</p>
            </div>
          </div>
        </Layout.Content>
      </Layout>
    )
  }
}

export default LoginLayout
